import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { StateType, hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_DRIVE,
    StoreType,
    DriveFileProps,
    LoadDriveFileById,
    setDriveFileEdit,
    setDriveFileReloadEdit,
    createFileName,
    isProjectFolderOpened,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageMenu,
    PageMenuButton,
    Tab,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"
import RevisionHistory from "../revisionList"

const DETAILS = "#details"
const REVISION_HISTORY = "#revisionHistory"

const FileEdit = ({
    fileId,
}: DriveFileProps) => {
    const drivePath = useSelector((state: StoreType) => state.drive.drivePath)
    const file = useSelector((state: StoreType) => state.drive.file.fileEdit)
    const reloadEdit = useSelector((state: StoreType) => state.drive.file.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [activeTab, setActiveTab] = useState(DETAILS)

    useEffect(() => {
        setLoadState(PENDING)
        LoadDriveFileById(fileId).then((res) => {
            dispatch(setDriveFileEdit(res))
            setLoadState(IDLE)

            dispatch(setDriveFileReloadEdit(false))
            setTimeout(() => {
                dispatch(setDriveFileReloadEdit(true))
            }, 0)
        })
    }, [])

    const projectId = isProjectFolderOpened(drivePath)

    const accountEditAccess = hasAccess(PRM_DRIVE, EDIT)
    const projectEditAccess = hasProjectAccess(PRM_DRIVE, EDIT, projectId)
    const editAccess = !projectId
        ? accountEditAccess
        : projectEditAccess

    const allowedToEdit = file && (
        (editAccess || file.owner === userData.userId)
        && file.accountId === userData.accountId
    )

    if (!file) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    { allowedToEdit ? `${lang.editFile} # ${file.id}` : createFileName(file) }
                </PageTitle>
            </PageHeader>
            <PageContent>
                <PageMenu>
                    <PageMenuButton
                        isActive={activeTab === DETAILS}
                        onClick={() => setActiveTab(DETAILS)}
                    >
                        {lang.details}
                    </PageMenuButton>
                    <PageMenuButton
                        isActive={activeTab === REVISION_HISTORY}
                        onClick={() => setActiveTab(REVISION_HISTORY)}
                    >
                        {lang.revisionHistory}
                    </PageMenuButton>
                </PageMenu>
                <Tab show={activeTab === DETAILS}>
                    {
                        loadState === PENDING
                        && <Loader />
                    }
                    {
                        !reloadEdit
                        && <Form file={file} editAccess={allowedToEdit} />
                    }
                    {
                        reloadEdit
                        && <Form file={file} editAccess={allowedToEdit} />
                    }
                </Tab>
                <Tab show={activeTab === REVISION_HISTORY}>
                    <RevisionHistory fileId={fileId} />
                </Tab>
            </PageContent>
        </Container>
    )
}
export default FileEdit
